import { useTranslation } from 'react-i18next';

export const VisualizationNoItemsMatchFiltersState = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col w-full items-center gap-4 py-8">
      <div className="text-xl font-bold">
        {t(($) => $.views.visualization.emptyStates.noItemsMatchFilters.title)}
      </div>
      <div className="mb-2 text-text-neutral-secondary">
        {t(($) => $.views.visualization.emptyStates.noItemsMatchFilters.description)}
      </div>
    </div>
  );
};
